import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The theme's `text-size-*` font sizes, which tailwind-merge would otherwise read
// as colours and drop beside one, and the named radii, so they replace each other.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ['control', 'card', 'panel'] }],
      'font-size': [
        {
          text: [
            'size-n3',
            'size-n2',
            'size-n1',
            'size-0',
            'size-1',
            'size-2',
            'size-3',
            'size-4',
            'size-5',
            'size-6',
            'size-7',
            'size-8',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

/**
 * Set a cookie value by name
 */
export function setCookie(name: string, value: string, maxAgeDays: number): void {
  document.cookie = `${name}=${value}; max-age=${maxAgeDays * 24 * 60 * 60}; path=/; SameSite=Lax`;
}

/**
 * Check if Django session cookies exist
 */
export function hasSessionCookie(): boolean {
  const sessionId = getCookie('sessionid');
  const csrfToken = getCookie('csrftoken') || getCookie('__Host-csrftoken');
  return !!(sessionId || csrfToken);
}

/**
 * Get CSRF token from cookies
 */
export function getCSRFToken(): string | null {
  // In production, Django uses __Host-csrftoken
  // In development, it uses csrftoken
  const csrfName = import.meta.env.PROD ? '__Host-csrftoken' : 'csrftoken';
  return getCookie(csrfName);
}
